'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var propConst = require('../../constants/propConst');
var projectLoadHelper = require('../../helper/projectLoadHelper');
var _ = require('underscore');
var util = require('../../helper/util');

/**
 * SVG组件
 * @author Allen
 * @createDate 2017/7/13
 **/

var SVG = React.createClass({

  paintEmpty: function () {
    if (!this.isEmptyImage) {
      return;
    }
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var g = canvas.getContext('2d');
    var w = canvas.width;
    var h = canvas.height;
    var caption = styleHelper.getPropertyValue(this.props, propConst.CAPTION) || this.props.controlTypeID;
    g.clearRect(0, 0, w, h);
    g.beginPath();
    g.strokeStyle = '#444';

    g.fillStyle = '#fff';
    g.lineWidth = 1;

    g.rect(0.5, 0.5, w - 1, h - 1);
    g.closePath();

    g.fill();
    g.stroke();

    var xLinePadding = 2;
    var yLinePadding = 2;

    g.moveTo(xLinePadding, yLinePadding);
    g.lineTo(w - xLinePadding, h - yLinePadding);
    g.moveTo(xLinePadding, h - yLinePadding);
    g.lineTo(w - xLinePadding, yLinePadding);
    g.stroke();


    var bgSize = 28;
    var captionSize = g.measureText(caption);
    var fontSize = 8;
    if (captionSize.width + 8 < w && fontSize + 5 < h) {
      g.fillRect(w / 2 - bgSize / 2, h / 2 - bgSize / 2, bgSize, bgSize);
      g.font = fontSize + 'px Arial';
      g.fillStyle = '#000';
      g.fillText(caption, w / 2 - captionSize.width / 2, h / 2 + fontSize / 2);
    }

  },

  componentDidMount: function () {
    this.paintEmpty();
  },

  componentDidUpdate: function () {
    this.paintEmpty();
    if (!this.isEmptyImage) {
      this.doPaint();
    }
  },

  isEmptyImage: false,
  render: function () {

    var url = styleHelper.getPropertyValue(this.props, propConst.URL);
    this.isEmptyImage = _.isEmpty(url);
    if (this.isEmptyImage) {
      return (
        <canvas
          ref="canvas"
          width={styleHelper.getWidth(this.props)}
          height={styleHelper.getHeight(this.props)}
        />
      )
    } else {
      url = projectLoadHelper.loadSVG(url);
      var w = styleHelper.getWidth(this.props);
      var h = styleHelper.getHeight(this.props);
      var style = {
        width: w,
        height: h,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      };

      return (

        <canvas ref='canvas2' style={style} width={w} height={h} >
          <img ref='imgDom' src={url} onLoad={this.drawImage}></img>
        </canvas>
      );
    }
  },


  doPaint: function() {
    var iwidth = styleHelper.getWidth(this.props);     //定义允许图片宽度
    var iheight = styleHelper.getHeight(this.props);     //定义允许图片高度
    var canvas = ReactDOM.findDOMNode(this.refs.canvas2);
    var imgDom = ReactDOM.findDOMNode(this.refs.imgDom);
    var color = styleHelper.getBackgroundColor(this.props);
    var context = canvas.getContext('2d');
    graphicsHelper.drawColorImage(context, imgDom, color, null, {left: 0, top: 0, right: iwidth, bottom: iheight})
  },

  drawImage: function (e) {
    var image = new Image();
    var iwidth = styleHelper.getWidth(this.props);     //定义允许图片宽度
    var iheight = styleHelper.getHeight(this.props);     //定义允许图片高度
    var ImgD = e.target;
    image.src = ImgD.src;
    if (image.width > 0 && image.height > 0) {
      if (image.width / image.height >= iwidth / iheight) {
        ImgD.width = iwidth;
        ImgD.height = (image.height * iwidth) / image.width;
        /*if (image.width > iwidth) {
          ImgD.width = iwidth;
          ImgD.height = (image.height * iwidth) / image.width;
        } else {
          ImgD.width = image.width;
          ImgD.height = image.height;
        }*/
        ImgD.alt = image.width + "×" + image.height;
      }
      else {
        ImgD.height = iheight;
        ImgD.width = (image.width * iheight) / image.height;
        /*if (image.height > iheight) {
          ImgD.height = iheight;
          ImgD.width = (image.width * iheight) / image.height;
        } else {
          ImgD.width = image.width;
          ImgD.height = image.height;
        }*/
        ImgD.alt = image.width + "×" + image.height;
      }
    }

    this.doPaint();
  }


});

module.exports = SVG;


// WEBPACK FOOTER //
// ./src/views/Components/SVG.jsx